export enum NotificationTypes {
  ChangedContactInfoNotification = "ChangedContactInfoNotification",
  ExtremeReactionNotification = "ExtremeReactionNotification",
  AttemptedThreeTimesNotification = "AttemptedThreeTimesNotification",
  AddressVerificationNotification = "AddressVerificationNotification",
  RemindMeNotification = "RemindMeNotification",
  NewContactNotification = "NewContactNotification",
  NewHouseholdAddressNotification = "NewHouseholdAddressNotification",
  ImportCompletedNotification = "ImportCompletedNotification",
  ImportAbortedNotification = "ImportAbortedNotification",
  ImportedAddressNotFoundNotification = "ImportedAddressNotFoundNotification",
  RoutesBatchCreatedNotification = "RoutesBatchCreatedNotification",
  RoutesBatchCreationFailedNotification = "RoutesBatchCreationFailedNotification",
  RouteDivisionCompletedNotification = "RouteDivisionCompletedNotification",
  RouteDivisionFailedNotification = "RouteDivisionFailedNotification",
  PendingHouseholdNotification = "PendingHouseholdNotification",
  VolunteerOffersCancelledNotification = "VolunteerOffersCancelledNotification",
  // The one-per-run "N addresses couldn't be placed on the map" summary. A type that
  // is NOT listed here falls through to a plain-text render, which is how this one
  // first shipped with its "Show them" link as dead text.
  AddressesNeedAttentionNotification = "AddressesNeedAttentionNotification",
}
